import {
  GET_TARGET_REQUEST, GET_TARGET_SUCCESS, GET_TARGET_FAIL, CREATE_TARGET_REQUEST, CREATE_TARGET_SUCCESS, CREATE_TARGET_FAIL,
  UPDATE_TARGET_REQUEST, UPDATE_TARGET_SUCCESS, UPDATE_TARGET_FAIL, DELETE_TARGET_REQUEST, DELETE_TARGET_SUCCESS, DELETE_TARGET_FAIL,
} from "../types/targetMasterTypes";
import cogoToast from 'cogo-toast';
import Axios from 'axios';
import APP_CONSTANT from '../../config/constants'
import { INVALID_TARGET_MONTH } from '../../config/const';

export const getTarget = (id) => async (dispatch) => {

  dispatch({ type: GET_TARGET_REQUEST });

  let token = localStorage.getItem('apiToken')
  let customerNo = localStorage.getItem('customerNo')
  let userId = localStorage.getItem('userId')

  try {

    const { data } = await Axios.get(`${APP_CONSTANT.BASE_URL}sales/target?customerNumber=${customerNo}&user_id=${userId}&customer_no=${customerNo}`, {
      headers: {
        'Content-Type': 'application/json',
        "Authorization": token,
        "Access-Control-Allow-Origin": "*"
      }
    });
    dispatch({ type: GET_TARGET_SUCCESS, payload: data });

  } catch (error) {
    dispatch({ type: GET_TARGET_FAIL, payload: error.message })
  }
}

export const createTarget = (createTargetData) => async (dispatch) => {

  dispatch({ type: CREATE_TARGET_REQUEST });

  try {
    
    const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}sales/target/create`, createTargetData, {
      headers: {
        'Content-Type': 'application/json',
        "Authorization": localStorage.getItem('apiToken'),
        "Access-Control-Allow-Origin": "*"
      }
    });
    dispatch({ type: CREATE_TARGET_SUCCESS, payload: data });

    if (data.status === 200) {
      cogoToast.error(data.message, { position: 'top-right' })
    } else {
      cogoToast.success(data.message, { position: 'top-right' }).then(() => {
        window.location.href = '/target';
      })
    }


  } catch (error) {
    cogoToast.error(INVALID_TARGET_MONTH, { position: 'top-right' })
    dispatch({ type: CREATE_TARGET_FAIL, payload: error.message })
  }
}

export const updateTarget = (updateTargetData, id) => async (dispatch) => {

  dispatch({ type: UPDATE_TARGET_REQUEST });

  try {
    const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}sales/target/update`, updateTargetData, {
      headers: {
        'Content-Type': 'application/json',
        "Authorization": localStorage.getItem('apiToken'),
        "Access-Control-Allow-Origin": "*"
      }
    });
    dispatch({ type: UPDATE_TARGET_SUCCESS, payload: data });

    if (data.status === 0) {
      cogoToast.error(data.message, { position: 'top-right' })
    } else {
      cogoToast.success(data.message, { position: 'top-right' }).then(() => {
        window.location.href = '/target';
      })
    }

  } catch (error) {
    dispatch({ type: UPDATE_TARGET_FAIL, payload: error.message })
  }
}


export const deleteTarget = (id) => async (dispatch) => {
  dispatch({ type: DELETE_TARGET_REQUEST });

  try {

    const headerData = {
      "api_token": localStorage.getItem('apiToken'),
      "customerNumber": localStorage.getItem('customerNo'),
      "userId": localStorage.getItem('userId'),
    }

    let customerNo = localStorage.getItem('customerNo')
    let userId = localStorage.getItem('userId')

    const { data } = await Axios.delete(`${APP_CONSTANT.BASE_URL}sales/target/delete/${id}?customer_no=${customerNo}&customerNumber=${customerNo}&user_id=${userId}`, {
      data: headerData,
      headers: {
        'Content-Type': 'application/json',
        "Authorization": localStorage.getItem('apiToken'),
        "Access-Control-Allow-Origin": "*"
      }
    });
    dispatch({ type: DELETE_TARGET_SUCCESS, payload: data });
    window.location.reload()


  } catch (error) {
    dispatch({ type: DELETE_TARGET_FAIL, payload: error.message })
  }
}